module.exports = __webpack_public_path__ + "img/icey-back.980aeaa3.png";